const VIEW_TYPES = {
	ANALYSIS: 'Analysis',
	EVIDENCE_TABLE: 'Evidence Table',
}

Object.freeze(VIEW_TYPES)
export default VIEW_TYPES
